module.exports = __webpack_public_path__ + "static/media/deck-carousel-1.174e4526.webp";